
































import { defineComponent, computed, ref } from "@vue/composition-api";
import dayjs from "dayjs";

export default defineComponent({
  name: "UniversityEntryTable",
  props: {
    data: {
      type: Array,
      default: []
    },
    chartData: {
      type: Array,
      default: []
    },
    period: {
      type: String,
      default: ""
    }
  },
  setup(props) {
    const displayPeriod = computed(() => props.period);
    const tableData = computed(() => {
      if (!props.data) {
        return [];
      }
      const data = props.data.map(e => {
        const el = e as {
          date: string;
          kdd: number;
          wkuik: number;
          gmarch: number;
          kkdr: number;
          ntks: number;
          skkl: number;
          national: number;
          other: number;
        };
        const date = dayjs(el.date).format("YYYYMMDD");
        const endDate = dayjs(el.date)
          .endOf("isoWeek")
          .format("YYYYMMDD");
        return {
          date:
            displayPeriod.value === "week"
              ? `${date.substring(0, 4)}/${date.substring(
                  4,
                  6
                )}/${date.substring(6, 8)} 〜 ${endDate.substring(
                  0,
                  4
                )}/${endDate.substring(4, 6)}/${endDate.substring(6, 8)}`
              : `${date.substring(0, 4)}/${date.substring(4, 6)}`,
          kdd: el.kdd,
          wkuik: el.wkuik,
          gmarch: el.gmarch,
          kkdr: el.kkdr,
          ntks: el.ntks,
          skkl: el.skkl,
          national: el.national,
          other: el.other
        };
      });
      return data;
    });

    const sumData = computed(() => props.chartData);

    const universities = ref([
      "旧帝大",
      "早慶上一工",
      "GMARCH",
      "関関同立",
      "日東駒専",
      "産近甲龍",
      "その他国公立",
      "その他"
    ]);

    return {
      universities,
      tableData,
      sumData
    };
  }
});
